<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-actions">
				<div className="sf-actions__left">
					<!-- <sf-button size="sm" line icon="square-plue" :onClick="addAction">
						{{ getMessage_('QWCC001488') }}
					</sf-button>
					<sf-button size="sm" line icon="file" :onClick="saveAction">
						{{ getMessage_('MWCC000327') }}
					</sf-button> -->
					<sf-button size="sm" line icon="square-plue" :onClick="addAction">
						{{ getMessage_('QWCC001488') }}
					</sf-button>
					<sf-button size="sm" line icon="file" :onClick="saveAction">
						{{ getMessage_('MWCC000327') }}
					</sf-button>
					<sf-button size="sm" line icon="trash" color="error" :onClick="deleteAction">
						{{ getMessage_('MWCC000328') }}
					</sf-button>
				</div>
			</div>
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">PPR번호</th>
							<td class="col-1"><el-input :value="mainKey" readOnly /></td>
							<th class="col-1">상태</th>
							<td class="col-1">
								<sf-select-group labelPosition="left" inputValue="All" :options="['ALL']" :onChange="() => {}" />
							</td>
							<th class="col-1">기종</th>
							<td class="col-1"><el-input v-model="input1" /></td>
							<th class="col-1">발생장소</th>
							<td class="col-1">
								<sf-select-group labelPosition="left" inputValue="All" :options="['ALL']" :onChange="() => {}" />
							</td>
							<th class="col-1">업체</th>
							<td class="col-1"><el-input v-model="input1" /></td>
						</tr>
						<tr>
							<th>긴급도</th>
							<td>
								<sf-select-group labelPosition="left" inputValue="All" :options="['ALL']" :onChange="() => {}" />
							</td>

							<th>불량수량</th>
							<td><el-input v-model="input1" /><span class="unit">EA</span></td>
							<th>라인정지</th>
							<td><el-input v-model="input1" /><span class="unit">분</span></td>
							<th>격리수량 부품</th>
							<td><el-input v-model="input1" /></td>
							<th>반제품</th>
							<td><el-input v-model="input1" /><span class="unit">EA</span></td>
						</tr>
						<tr>
							<th>발생일</th>
							<td><el-date-picker v-model="date1" /></td>
							<th>제기일</th>
							<td><el-date-picker v-model="date1" /></td>
							<th>회선요구일</th>
							<td><el-date-picker v-model="date1" /></td>
							<th>불량유형</th>
							<td><sf-select-group labelPosition="left" inputValue="All" :options="['ALL']" :onChange="() => {}" /></td>
							<td colspan="2"><sf-select-group labelPosition="left" inputValue="All" :options="['ALL']" :onChange="() => {}" /></td>
						</tr>
						<tr>
							<th>대책회신</th>
							<td><sf-select-group labelPosition="left" inputValue="All" :options="['ALL']" :onChange="() => {}" /></td>
							<td colspan="2"><el-input v-model="input1" /></td>
							<th>조직구분</th>
							<td><sf-select-group labelPosition="left" inputValue="All" :options="['ALL']" :onChange="() => {}" /></td>
							<th>라인정지</th>
							<td><el-input v-model="input1" /><span class="unit">분</span></td>
							<th>품번구분</th>
							<td><sf-select-group labelPosition="left" inputValue="All" :options="['ALL']" :onChange="() => {}" /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

export default {
	data() {
		return {
			data: '',
			date1: '',
			input1: '',
			pprNo: ''
		};
	},
	props: {
		scrId: { type: String, default: '' },
		mainKey: { type: String, default: '' },
		blankScrId: { type: String, default: '' }
	},
	created() {
		this.pprNo = this.mainKey;
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		change(value) {
			// this.setSearchParam_({ key: 'useYn', value: value });
			// this.$emit('search');
		},
		addAction() {},
		saveAction() {
			this.setState_({ key: 'isSaveFlag', value: true });
			//console.log('1.TableMaterInfo => getSaveDataObj3_ 수행 ::: ', this.getSaveDataObj3_);

			try {
				// 유효성 검사
				//this.schema.validateSync(this.UploadFormModalValue);

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('MWCC000503'), //추가하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001488'), clickFn: () => this.save() }], //추가,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		save() {
			const formData = new FormData();
			//console.log('getResultObj_  >>>>>> ', this.resultObj_);
			//console.log('7.actions 호출 시작');

			//return false;
			// actions 호출
			this.$sf_toggleLoading(true);
			this.saveFreeForm_({ formData })
				.then(response => {
					if (response.code == 0) {
						this.$sf_toast({ type: 'ok', message: '저장하였습니다.' });
						//this.getTestInfo_(this.pprNo); // 내용을 불러와 다시세팅
					} else {
						this.$sf_toast({ type: 'error', message: response.message });
					}
					this.setState_({ key: 'isSaveFlag', value: true }); //false로 설정
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
					Promise.reject(error);
					this.$sf_toggleLoading(false);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		deleteAction() {
			try {
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: () => this.delete() }] //삭제,
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		async delete() {
			this.$sf_toggleLoading(true);
			//console.log('...this.pprNo', this.pprNo);
			this.deleteFreeForm_({ key: 'gqmsSeq', value: this.pprNo })
				.then(response => {
					this.$sf_toast({ type: 'ok', message: response.message });
					// 2.삭제완료되면 탭화면 닫기
					this.$sf_removeTab(this.blankScrId);

					// 3.open 했던 Tab 다시 불러오기, 아래 item은 부모창을 먼저 닫았을경우 새로 다시 띄워주기 위함
					let item = {
						scrId: this.scrId,
						name: 'GridFreeForm', //this.getMessage_('MWCC000438'), //탭에 표시하기 위한 이름, 다국어: 사이트맵
						component: () => import('@qms/GridFreeForm/GridFreeForm.vue').catch(() => {}),
						msgKey: 'MWCC000438'
					};

					this.$sf_addTab(item, this.scrId, { scrId: this.scrId, reloading: true });
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
